/**
 * FASE 4.2 — PrefillWelcomeBanner
 * Banner mostrato all'inizio dei wizard quando l'utente è loggato e i dati
 * sono stati pre-compilati dal profilo.
 *
 * Se `customerName` è vuoto/null, mostra messaggio generico senza il nome
 * (NON usiamo MAI la local-part dell'email).
 */
import { Sparkles, X } from "lucide-react";
import { useState } from "react";

export default function PrefillWelcomeBanner({ customerName }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  const displayName = (customerName || "").trim();
  return (
    <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-3 flex items-start gap-3 mb-4"
      data-testid="prefill-welcome-banner">
      <Sparkles className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-emerald-900" data-testid="prefill-banner-title">
          {displayName ? `Bentornato/a ${displayName}! 👋` : "Bentornato/a! 👋"}
        </p>
        <p className="text-xs text-emerald-800 mt-0.5">
          I tuoi dati sono già pre-compilati. Modificali se necessario, oppure procedi direttamente.
        </p>
      </div>
      <button onClick={() => setDismissed(true)}
        className="text-emerald-700 hover:text-emerald-900 p-1"
        data-testid="prefill-banner-dismiss" aria-label="Chiudi banner">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
